import jwtDecode from 'jwt-decode';
import { checkUserExist } from 'aster-foundation/core/astercore/auth/login/redux/actions';
import { authUserLogOut, authRefreshToken, authGuestToken  } from 'aster-foundation/core/astercore/authService/redux/actions';
import { getLoyaltyCustomer } from 'aster-foundation/core/astercore/loyalty/redux/actions';
import { getPatientProfile } from 'aster-foundation/core/astercore/profile/profile/redux/actions';
import { REDIRECT_URI } from 'aster-foundation/core/common/utils/ApiConst';
import {
  getDataFromCookie,
  getDataFromCookieAToB,
  removeAllCookie,
  removeCookieByName,
  setDataToCookie,
} from 'aster-foundation/core/common/utils/cookieHelper';
import { getCartDetails, mergeCartDetails } from 'aster-foundation/core/epharmacy/Cart/redux/actions';
import { getWishList } from 'aster-foundation/core/epharmacy/wishlist/redux/actions';
import { getWishListHomecareSkuIDs } from 'aster-foundation/core/homecare/wishlist/redux/actions';
import {
  getNotificationsList,
  setNotificationsAsRead,
} from 'aster-foundation/core/teleconsultant/notifications/redux/actions';
import { createReferredUser } from 'aster-foundation/core/epharmacy/Referrals/redux/action';
import { getUaePassLogoutRedirectUrl } from 'aster-foundation/core/astercore/auth/uaepass/redux/actions';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import smartlookClient from 'smartlook-client';
import { v4 as uuidv4 } from 'uuid';
import { getUserCountry } from '../../../TeleConsultation/common/utils/getUserCountry';
import { dataLayerSendEvent, getProductItemObject } from '../../../Epharmacy/EpharmacyAnalytics';
import { setTotalQtyData } from '../../../Epharmacy/MyCart/redux/reducer';
import { setWishListData, setWishListSkuIds } from '../../../Epharmacy/MyShoppingList/redux/reducer';
import { setProductItemQtyMultiple } from '../../../Epharmacy/ProductDetails/redux/reducer';
import { useAuth } from '../../AuthService';
import {
  IC_BELL,
  IC_CART_GREY,
  IC_CLOSE,
  IC_HAMBURGER,
  IC_HEART_MANDALAY,
  IC_LOGOUT_GREY,
  IC_LOGOUT_WHITE,
  IC_TICK,
  IC_USER,
  IC_VM_MY_PROFILE_CIRCLE,
  IC_VM_MY_PROFILE_WHITE_CIRCLE,
  LOGO_ASTER,
  LOGO_ASTER_SECURE,
  LOGO_ASTER_AR,
} from '../../Assets/images';
import HomeCareContext from '../../Context/HomeCareContext';
import useScrollHandler from '../../Context/useScrollHandler';
import { dataLayerMenuClickEvent, sendLoginEvent } from '../../Utility/analytics-utils';
import {
  MIN_MOBILE_WIDTH,
  checkIfCurrentLangIsArabic,
  checkIfCurrentRegionIsSaudi,
  checkTokenValidity,
  convertStringtoTitleCase,
  destructureAndGetCurrentCartItemsList,
  errorHandling,
  errorHandlingEpharmacy,
  getIsInstoreApp,
  setIsInStoreApp,
  clearAppStorage
} from '@common/Utility/common-utils';
import {
  HOME_CARE_ROUTE,
  ONLINE_PHARMACY_ROUTE,
  PAYMENT_CURRENCY,
  TELECONSULT_ROUTE,
  INSTORE,
  AE_GLOBAL,
  CLICKEDMENU,
  TRUE,
  FALSE,
  FLAGSMITH_KEYS,
  LOCALSTORAGE_KEYS,
  CART_TYPES,
  PAGE_NAMES,
  PAGE_TYPES,
  WISHLIST_TYPES,
  USER_TYPES,
  MY_CART_ROUTE,
  ONLINE_PHARMACY_PAYMENT_SUCCESS,
  HOME,
  REGION_SWITCHER_DISALLOWED_URLS,
  PROMOTION_LEAFTLET_ROUTE,
  SESSION_STORAGE_KEYS,
} from '@common/Utility/constants';
import { flagsmith } from '../../../Common/Lib/Flagsmith';
import { EventEmitter } from '../../Utility/eventEmitter';
import useIsNotSafari from '../../Utility/hooks';
import { getProductDetailsAttributes, updateUserData } from '../../Utility/insider-object-integration';
import { sendEventToSmartLook } from '../../Utility/smartlook';
import { dataLayerLogin, dataLayerMenu } from '../BookAppointment/BookAppointmentAnalytics';
import { ButtonBase, DropdownControl } from '../Forms/index';
import CustomModal from '../Modal/Modal';
import SmartBanner from '../SmartBanner/SmartBanner';
import { HeaderStyled } from './HeaderStyled';
import UserProfileSkeleton from './UserProfileSkeleton';
import logger from '@common/Utility/logger';
import { getPage } from '@common/Constants/analytics';
import { cartInfoUpdate } from 'Epharmacy/MyCart/MyCartEvents';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const MenuSideNavigation = dynamic(() => import('../MenuSideNavigation/MenuSideNavigation'));
const ToastControl = dynamic(() => import('../ToastControl/ToastControl'));
const Loader = dynamic(() => import('../Loader/Loader'));
const QuickNotifications = dynamic(() => import('../QuickNotifications/QuickNotifications'));
const SearchBox = dynamic(() => import('../SearchBox/SearchBox'));
const VideoCallPopover = dynamic(() => import('../VideoCallPopover/VideoCallPopover'));

const userDropdownData = [
  {
    icon: IC_VM_MY_PROFILE_CIRCLE,
    iconHover: IC_VM_MY_PROFILE_WHITE_CIRCLE,
    text: 'Account',
    value: 'myProfile',
    divider: false,
  },
  {
    icon: IC_LOGOUT_GREY,
    iconHover: IC_LOGOUT_WHITE,
    value: 'Logout',
    text: 'Logout',
    divider: false,
  },
];

const Header = (props) => {
  const scrollY = useScrollHandler();
  const dispatch = useDispatch();
  const router = useRouter();
  const ref = useRef();
  const t = useTranslation();
  const generateURL = useNavigationURL();
  const mergeCartRef = useRef(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isGuest, setIsGuest] = React.useState(null);
  const { authCtx, initialized } = useAuth();
  const [isQuickNotification, setIsQuickNotification] = React.useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotification, setShowNotification] = useState(true);
  const [show, setShow] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showHemburgerResponsive, setShowHemburgerResponsive] = useState(false);
  const [isMergeCartModalOpen, setIsMergeCartModalOpen] = useState(false);
  const [toastControlMessage, setToastControlMessage] = React.useState(null);
  const [toastControlImage, setToastControlImage] = React.useState(IC_TICK);
  const [toastControlClass, setToastControlClass] = React.useState('');
  const [showActiveMenu, setShowActiveMenu] = React.useState(true);
  const [isArLang, setIsArLang] = useState(false);
  const [currentLang, setCurrentLanguage] = useState('');
  
  const homeCarePage = useContext(HomeCareContext);
  const [isHomeCarePage, setHomeCarePage] = useState(homeCarePage?.homeCareSearch || false);

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const getCartV2Data = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const createRxCart = useSelector((state) => state?.epharmacy?.createRxCart?.data);
  const myCartTotalItems = useSelector((state) => state?.app?.myCartReducer?.totalItems);
  const [userData, setUserData] = useState(userLogin);
  const loading = useSelector((state) => state?.astercore?.checkUserExist?.isFetching);
  const mergeCartLoader = useSelector((state) => state?.epharmacy?.mergeCart?.isFetching);
  const newMergeCartLoader = useSelector((state) => state?.epharmacy?.newMergeCart?.isFetching);
  const cancelMergeCartLoader = useSelector((state) => state?.epharmacy?.cancelMergeCart?.isFetching);
  const meeting = useSelector((state) => state?.app?.waitingRoomReducer?.meeting);
  const asterSecureLoyaltics = useSelector((state) => state?.astercore?.getLoyaltyData?.data?.data);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const getWishlistLoader = useSelector((state) => state?.epharmacy?.getWishList?.isFetching);
  const addToWishlistLoader = useSelector((state) => state?.epharmacy?.addToWishList?.isFetching);
  const removeFromWishlistLoader = useSelector((state) => state?.epharmacy?.removeFromWishList?.isFetching);
  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const userArea = useSelector((state) => state?.app?.userLocationReducer?.area);
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo)
  const patientProfile = useSelector((state) => state?.astercore?.patientProfile?.data);
  const userAddresses = useSelector((state) => state?.epharmacy?.getUserAddress?.data?.data);

  const getLatestZoneData = () => localStorage?.getItem('userZone') || zoneData?.join(',');
  const ae_web_insider = flagsmith.getValue('ae_web_insider', { json: true });
  const referralFlag = flagsmith.getValue(FLAGSMITH_KEYS.REFERRAL_COUPON, { json: true });
  const instoreFlag = flagsmith.getValue('ae_web_instore_checkout', { json: true });
  const insiderVariationId = ae_web_insider?.variationId;
  const mergeCartEnabled = flagsmith.getValue(FLAGSMITH_KEYS.MERGE_SHIPMENT, { json: true })?.mergeCartEnabled;
  const cartCheckoutFlag = flagsmith.getValue(FLAGSMITH_KEYS.CART_AND_CHECKOUT, { json: true });
  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;
  let cartIconAnimation = typeof window !== 'undefined' && window.localStorage?.getItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION);
  const wobbleTimerRef = useRef(null);
  const [isWobbleAnimation, setIsWobbleAnimation] = useState(cartIconAnimation);
  const localStorageSelectedAddressData = typeof window !== 'undefined' && localStorage.getItem('selectedAddressData');
  const isMergeCalled = typeof window !== 'undefined' && sessionStorage.getItem(SESSION_STORAGE_KEYS?.IS_MERGE_CART_CALLED);

  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  const isDisallowedSwitcher = REGION_SWITCHER_DISALLOWED_URLS.some((disallowedPath) => router?.asPath?.split('?')?.[0]?.indexOf(disallowedPath) > -1);

  useEffect(() => {
    setIsClient(true);
    if(window !== 'undefined' && checkIfCurrentLangIsArabic()){
      setIsArLang(true);
    }
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  const timer = useRef();
  const guestTokenTimer = useRef();
  const cartBoxRef = useRef();

  const isFromMobileApp = router?.query?.isFromMobileApp?.toLowerCase() === 'true';

  const referralCode = router?.query?.referral;

  useEffect(() => {
    if (router?.pathname?.indexOf(HOME_CARE_ROUTE) > -1) {
      setHomeCarePage(true);
    }
  }, [router?.pathname]);

  const fetchWishList = (data) => {
    const zoneData = data?.zone || userZoneData;
    const userData = data?.userLogin || userLogin;
    if (
      authCtx?.authenticated &&
      (router?.route === '/' ||
        String(router?.asPath).includes(ONLINE_PHARMACY_ROUTE) ||
        String(router?.asPath).includes('/lists') || 
        String(router?.asPath).includes(PROMOTION_LEAFTLET_ROUTE)) && !!zoneData && !!userData?.id
    ) {
      const params = {
        wishlist_type: WISHLIST_TYPES.AE,
        userId: userData?.id,
        zones: encodeURIComponent(JSON.stringify(zoneData))
      };
 
        dispatch(
          getWishList({
            param: params,
            onSuccess: (response) => {
              if(response?.items?.length > 0) {
                dispatch(setWishListData(response?.items?.filter((product) => product.status === '1')));
                dispatch(setWishListSkuIds(response?.items?.map(item => item.sku)));
              } else {
                dispatch(setWishListData([]));
                dispatch(setWishListSkuIds([]));
              }
            },
            onFailure: (err) => {
              errorHandlingEpharmacy(err, true, props?.screenName || 'HomePage', props?.pageType);
            },
          }),
        );
    }
  };

  const fetchHomeCareWishList = () => {
    if (authCtx?.authenticated && router?.route === '/' && String(router?.asPath).includes(HOME_CARE_ROUTE)) {
      dispatch(
        getWishListHomecareSkuIDs({
          onSuccess: (response) => {},
          onFailure: () => {},
        }),
      );
    }
  };

  useEffect(() => {
    if (userLogin) {
      updateUserData({
        ...userLogin,
        loyaltyPoints: asterSecureLoyaltics?.availablePoints,
        loyaltyPointsAmount: asterSecureLoyaltics?.amount,
      });
    }
  }, [userLogin, asterSecureLoyaltics]);

  useEffect(() => {
    if (!userLogin || !referralFlag?.enabled) return;

    const referralValue = referralCode || localStorage.getItem(LOCALSTORAGE_KEYS.REFERRAL_CODE);
    if (referralValue && referralValue !== TRUE && referralValue !== FALSE) {
      const referredUserParams = {
        userId: userLogin?.id,
        email: userLogin?.telecom?.find((e) => e.system === 'email')?.value,
        mobile: userLogin?.telecom?.find((e) => e.system === 'phone')?.value,
        referralCode: referralValue,
      };
      dispatch(
        createReferredUser({
          params: referredUserParams,
          onSuccess: (res) => {
            localStorage.removeItem(LOCALSTORAGE_KEYS.REFERRAL_CODE);
          },
          onFailure: (err) => {
            errorHandling(err, true);
            localStorage.removeItem(LOCALSTORAGE_KEYS.REFERRAL_CODE);
          },
        }),
      );
    }
  }, [userLogin]);

  React.useEffect(() => {
    if (authCtx?.authenticated) {
      fetchHomeCareWishList();
    }
    
    if(router?.pathname.includes(MY_CART_ROUTE) && (userLogin?.id && isMergeCalled === 'true' || !!guestLogin?.accessToken)) {
      const selectedAddress = userAddresses?.find(address => address.selected === true);
      if(Object.keys(selectedAddress || {})?.length > 0 && JSON.stringify(selectedAddress) !== localStorageSelectedAddressData) {
        fetchCartDetails();
      }
    } else if(!getCartV2Data?.delivery_groups?.length > 0 && userLogin?.id && isMergeCalled === 'true' && !mergeCartRef.current) {
      fetchCartDetails();
    }
  }, [authCtx?.authenticated, zoneData]);

  const checkUserExistFunc = () => {
    if (authCtx?.idTokenParsed?.sub) {
      dispatch(
        checkUserExist({
          params: {
            mobile: encodeURIComponent(authCtx?.idTokenParsed?.mobile_number),
            id: authCtx?.idTokenParsed?.sub,
          },
          onSuccess: () => {
            EventEmitter.dispatch('CheckFamilyMemberinHis');
          },
          onFailure: (err) => {
            errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
          },
        }),
      );
    }
  };

  const getGuestToken = () => {
    const uuid = getDataFromCookie('deviceId') ? getDataFromCookie('deviceId') : uuidv4();
    setDataToCookie('deviceId', uuid, 10);
    removeCookieByName('userId');
    const isValid = getDataFromCookie('Guest_Token') ? checkTokenValidity(getDataFromCookie('Guest_Token')) : false;
    if (!isValid || !guestLogin) {
      dispatch(
        authGuestToken({
          requestParams: null,
          onSuccess: (response) => {
            if (response?.body?.success) {
              setDataToCookie('Guest_Token', response?.body?.guestToken);
              setIsGuest(true);
              if (sessionStorage.getItem('bookAppointmentLogin')) {
                const path = JSON.parse(sessionStorage.getItem('bookAppointmentLogin'));
                router.push({
                  pathname: generateURL(path?.pathname),
                  query: path?.query,
                });
              }
              if (sessionStorage.getItem('redirectToCheckout') && router?.asPath?.indexOf('/paymentsuccess') < 0) {
                const path = JSON.parse(sessionStorage.getItem('redirectToCheckout'));
                router.push({
                  pathname: generateURL(path.pathname),
                  query: path.query,
                });
              }
              initGuestTokenTimer();
            }
          },
          onFailure: (err) => {
            errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
            logger.error('Error occurred in getting the Guest Token ::', err);
          },
        }),
      );
    }
  };

  const fetchCartDetails = ({ cartIdParam, callwithoutCartId = false } = {}) => {
    let cartId;
    const oldCartId = sessionStorage.getItem(SESSION_STORAGE_KEYS?.OLD_CART_ID);
    const isPaymentPage = router?.pathname?.includes(ONLINE_PHARMACY_PAYMENT_SUCCESS);
    const isOnlinePharmacyPage = router?.pathname?.includes(ONLINE_PHARMACY_ROUTE);
    
    if (
      createRxCart?.body?.cart_id !== undefined &&
      getCartV2Data?.cart_id !== undefined &&
      createRxCart?.body?.cart_id === getCartV2Data?.cart_id
    ) {
      cartId = oldCartId;
    } else if (Number(oldCartId) !== undefined && getCartV2Data?.cart_id !== undefined && Number(oldCartId) !== getCartV2Data?.cart_id) {
      cartId = oldCartId;
    } else if (isPaymentPage) {
      cartId = oldCartId;
    } else {
      cartId = oldCartId;
    }

    props?.setCartPageLoading(true);
    const { page } = getPage(router?.asPath);

    const params = {
        cartId: !!isPaymentPage || !!(getIsInstoreApp() && isOnlinePharmacyPage) || callwithoutCartId ? '' : cartIdParam || cartId || getCartV2Data?.cart_id,
        "cart_type": CART_TYPES.AE,
        "merge_shipment": false,
        page,
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    if (!checkIfCurrentRegionIsSaudi() && !!userZoneData && (!!guestLogin || !!userLogin)) {
      params.zones = encodeURIComponent(JSON.stringify(userZoneData));
      if (router?.asPath?.includes('mycart')) {
        props?.setCartRes(null);
      }
      dispatch(
        getCartDetails({
          param: params,
          onSuccess: (response) => {
            props?.setCartPageLoading(false);
            if (response?.delivery_groups) {
              cartInfoUpdate(response);
              dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(response)));
              if (router?.asPath?.includes('mycart')) {
                props?.setCartRes(response?.delivery_groups);
              }
            }
            dispatch(setTotalQtyData(response?.total_quantity));
            sessionStorage.setItem(SESSION_STORAGE_KEYS?.OLD_CART_ID, response?.cart_id);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, props?.screenName || 'HomePage', props?.pageType);
            if(err?.data?.errors?.[0]?.error_code === 'CART017') {
              sessionStorage.removeItem(SESSION_STORAGE_KEYS?.OLD_CART_ID);
              fetchCartDetails({ callwithoutCartId: true });
            }
            props?.setCartPageLoading(false);
          },
        }),
      );
    }
  }

  /**
   * this to be called from cart page after wishlist operations via event emitter
   * 
   */
  // TODO:7671 after testing will remove
  /* const getCartInfosV1 = (data) => {
    const userLoginData = data?.userLogin || userLogin;
    const guestLoginData = data?.guestLogin || guestLogin;
    if (router?.asPath?.indexOf(PAGE_NAMES.CHECKOUT) < 0 && router?.asPath?.indexOf(PAGE_NAMES.SP_CHECKOUT) < 0) {      
      const params = { 
        userId: userLogin?.id,
        cartId: getCartV2Data?.cart_id,
        "cart_type": CART_TYPES.AE,
        "merge_shipment": false,
        page: router?.pathname.includes(PAGE_TYPES.CHECKOUT) ? PAGE_TYPES.CHECKOUT : PAGE_TYPES.CART,
      };
      if (userZoneData) {
        params.zones = encodeURIComponent(JSON.stringify(userZoneData));

        if (guestLoginData || userLoginData) {
          if (router?.asPath?.includes('mycart')) {
            props?.setCartRes(null);
          }
          dispatch(
            getCartDetails({
              param: params,
              onSuccess: (response) => {
                props?.setCartPageLoading(false);
                if (response?.delivery_groups) {
                  cartInfoUpdate(response);
                  dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(response)));
                  if (router?.asPath?.includes('mycart')) {
                    props?.setCartRes(response?.delivery_groups);
                  }
                }
                dispatch(setTotalQtyData(response?.total_quantity));
              },
              onFailure: (err) => {
                errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
                props?.setCartPageLoading(false);
              },
            }),
          );
        }
      }
    }
  }; */

  // TODO:7671 after testing will remove
  /* const getCartInfos = (mergeCheck = false, shouldCallV1 = true) => {
    setIsCartMergeCalled(true);
    props?.setCartPageLoading(true);
    const params = { 
      userId: userLogin?.id,
      cartId: getCartV2Data?.cart_id,
      "cart_type": CART_TYPES.AE,
      "merge_shipment": false,
      page: router?.pathname.includes(PAGE_TYPES.CHECKOUT) ? PAGE_TYPES.CHECKOUT : PAGE_TYPES.CART,
    };
    if (userZoneData) {
      params.zones = encodeURIComponent(JSON.stringify(userZoneData));
    }
    if (guestLogin || userLogin) {
      if (mergeCheck) {
        dispatch(
          getCartDetails({
            param: params,
            onSuccess: (response) => {
              if (response?.delivery_groups) {
                dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(response)));
              }
              dispatch(setTotalQtyData(response?.total_quantity));
            },
            onFailure: (err) => {
              errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
              props?.setCartPageLoading(false);
            },
          }),
        );
      } else {
        if (shouldCallV1) {
          getCartInfosV1();
        }
      }
    }
  }; */

  const getNotifications = ( userData ) => {
    if (userData?.id) {
      const requestParams = {
        userId: userData?.id,
        userType: USER_TYPES.PATIENT,
        allProfile: true,
      };
      if (userData) {
        dispatch(
          getNotificationsList({
            requestParams,
            onSuccess: (response) => {
              setNotifications(response?.data);
            },
            onFailure: (err) => {
              errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
            },
          }),
        );
      }
    }
  }

  useEffect(() => {
    if (!isFromMobileApp && !meeting && getDataFromCookie('Teleconsult_id')) {
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/appointments/${getDataFromCookie('Teleconsult_id')}/videocall`),
        query: { isFromMobileApp },
      });
    }
  }, [meeting, router]);

  useEffect(() => {
    if (!isQuickNotification && showNotification === false && userData?.id) {
      const requestParams = {
        userId: userData?.id,
        userType: 'Patient',
        allProfile: true,
      };
      dispatch(
        setNotificationsAsRead({
          requestParams,
          onSuccess: (response) => {
            setNotifications(response?.data);
          },
          onFailure: (err) => {
            errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
          },
        }),
      );
    }
  }, [isQuickNotification, showNotification]);

  useEffect(() => {
    setDataToCookie('User_Data', userData?.id);
    localStorage.setItem('PayByPoints', 'false');
    if (
      router?.asPath?.indexOf(`${ONLINE_PHARMACY_ROUTE}/rxupload`) !== 0 &&
      !router?.asPath?.split('?')?.includes('/insurance') &&
      router?.asPath !== '/insurance'
    ) {
      localStorage.removeItem('rxNo');
      if (localStorage?.getItem('isLogin') !== 'true') {
        localStorage.removeItem('uploadedDocs');
        localStorage.removeItem('erxId');
      }
    }
  }, [userData?.id]);

  useEffect(() => {
    getNotifications(userData);
    timer.current = setInterval(() => {
      getNotifications(userData);
    }, 2 * 60 * 1000);
    return () => {
      clearInterval(timer.current);
    };
  }, [userData?.id]);

  const checkPatientInHis = (userDataInfo) => {
    dispatch(
      getPatientProfile({
        params: {
          _query: 'checkPatientInHis',
          userId: userDataInfo?.id,
        },
        onSuccess: (response) => {
          checkUserExistFunc();
          if (sessionStorage.getItem('bookAppointmentLogin')) {
            if (
              response?.entry[0]?.resource?.extension?.find((e) => e.url === 'status')?.valueString !==
              'incomplete profile'
            ) {
              if (sessionStorage.getItem('instantGpCompleteProfile')) {
                sessionStorage.setItem('instantGpCompleteProfile', 'true');
              }
              const path = JSON.parse(sessionStorage.getItem('bookAppointmentLogin'));
              router.push({
                pathname: generateURL(path.pathname),
                query: path.query,
              });
            } else {
              router.push({
                pathname: generateURL('/doctor-consultation/completeprofile'),
                query: { path: sessionStorage.getItem('bookAppointmentLogin') },
              });
            }
          }
          if (sessionStorage.getItem('redirectToCheckout') && router?.asPath?.indexOf('/paymentsuccess') < 0) {
            const path = JSON.parse(sessionStorage.getItem('redirectToCheckout'));
            router.push({
              pathname: generateURL(path.pathname),
              query: path.query,
            });
          }
        },
        onFailure: (err) => {
          if (sessionStorage.getItem('bookAppointmentLogin')) {
            router.push({
              pathname: generateURL('/doctor-consultation/completeprofile'),
              query: { path: sessionStorage.getItem('bookAppointmentLogin') },
            });
          }
          errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
        },
      }),
    );
  };

  const updateToken = () => {
    const requestParams = {
      refreshToken: getDataFromCookie('kcRefreshToken'),
    };

    dispatch(
      authRefreshToken({
        requestParams,
        onSuccess: (response) => {
          authCtx.setToken(response?.body);
          setDataToCookie('userId', authCtx?.idTokenParsed?.sub);
          removeCookieByName('Guest_Token');
          setDataToCookie('deviceId', getDataFromCookie('deviceId') ? getDataFromCookie('deviceId') : uuidv4(), 10);
          fetchCartDetails();
        },
        onFailure: (err) => {
          errorHandling(err);
          removeAllCookie();
          router.push({ pathname: generateURL('/') });
        },
      }),
    );
  };

  const handleNewRegistrationUser = (userInfo) => {
    if (
      sessionStorage.getItem('isFromRxUpload') &&
      userInfo?.extension?.find((item) => item.url === 'hisSystem')?.valueIdentifier
    ) {
      sessionStorage.setItem('userAlreadyRegistered', 'true');
    }
    if (
      sessionStorage.getItem('bookServiceLogin') &&
      !userInfo?.extension?.find((item) => item.url === 'hisSystem')?.valueIdentifier
    ) {
      sessionStorage.setItem('bookServiceLogin', 'true');
    }
  };

  useEffect(() => {
    if (getDataFromCookieAToB('kcToken') && !authCtx?.isTokenValid()) {
      updateToken();
    }

    authCtx.onTokenExpired = () => {
      if (getDataFromCookieAToB('kcToken') && !authCtx?.isTokenValid()) {
        updateToken();
      }
    };

    if (authCtx?.authenticated && initialized) {
      const userProperties = {
        userId: authCtx?.idTokenParsed?.sub,
        email: authCtx?.idTokenParsed?.email,
        name: authCtx?.idTokenParsed?.name,
        mobileNumber: authCtx?.idTokenParsed?.mobile_number,
      };
      smartlookClient.identify(authCtx?.idTokenParsed?.email, userProperties);
      if (!getDataFromCookieAToB('kcToken')) {
        dataLayerLogin('Login_Success');
        const properties = {
          type: 'login_success',
        };
        sendEventToSmartLook('login_success', properties);
      }
      removeCookieByName('Guest_Token');
      setDataToCookie('userId', authCtx?.idTokenParsed?.sub);
      setDataToCookie('deviceId', getDataFromCookie('deviceId') ? getDataFromCookie('deviceId') : uuidv4(), 10);
      if (localStorage.getItem('PreselectedPatientId')) {
        if(!patientProfile || router?.pathname?.indexOf('profile/myprofile') > -1){
          dispatch(
            getPatientProfile({
              params: { userId: localStorage.getItem('PreselectedPatientId') },
              onSuccess: (response) => {
                setUserData(response);
                setIsGuest(false);
                fetchCartDetails();
                removeCookieByName('Guest_Token');
              },
              onFailure: (err) => {
                errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
                // const eventName = 'login_email_error';
                // const properties = {
                //   type: 'login_email_error',
                // };
                // Smartlook.track('login_email_error', eventName, properties);
              },
            }),
          );
        }
        if (!userLogin) {
          checkUserExistFunc();
        }
      } else if (!userLogin) {
        const isCheckoutCall = !userLogin && router?.pathname?.includes(`${ONLINE_PHARMACY_ROUTE}/mycart`);
        dispatch(
          checkUserExist({
            params: {
              mobile: encodeURIComponent(authCtx?.idTokenParsed?.mobile_number),
              id: authCtx?.idTokenParsed?.sub,
              isCheckoutCall,
            },
            onSuccess: (response) => {
              handleNewRegistrationUser(response.entry[0].resource);
              setUserData(response.entry[0].resource);
              setIsGuest(false);
              if (!getCartV2Data?.delivery_groups?.length > 0 && isMergeCalled === 'true') {
                fetchCartDetails();
              }
              removeCookieByName('Guest_Token');
              if (
                response?.entry[0]?.resource?.extension?.find((e) => e.url === 'status')?.valueString ===
                'incomplete profile'
              ) {
                checkPatientInHis(response.entry[0].resource);
              }
              if (sessionStorage.getItem('bookAppointmentLogin')) {
                if (
                  response?.entry[0]?.resource?.extension?.find((e) => e.url === 'status')?.valueString !==
                  'incomplete profile'
                ) {
                  if (sessionStorage.getItem('instantGpCompleteProfile')) {
                    sessionStorage.setItem('instantGpCompleteProfile', 'true');
                  }
                  const path = JSON.parse(sessionStorage.getItem('bookAppointmentLogin'));
                  router.push({
                    pathname: generateURL(path.pathname),
                    query: path.query,
                  });
                }
              }
              if (sessionStorage.getItem('redirectToCheckout') && router?.asPath?.indexOf('/paymentsuccess') < 0) {
                const path = JSON.parse(sessionStorage.getItem('redirectToCheckout'));
                router.push({
                  pathname: generateURL(path.pathname),
                  query: path.query,
                });
              }
            },
            onFailure: (err) => {
              errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
            },
          }),
        );
      }

      localStorage.setItem('isGuest', false);
    } else if (!authCtx?.authenticated && initialized) {
      if (getDataFromCookie('Guest_Token')) {
        const isValid = checkTokenValidity(getDataFromCookie('Guest_Token'));
        if (isValid === false) {
          getGuestToken();
        } else {
          getGuestToken();
        }
      } else {
        getGuestToken();
      }
      // const eventName = 'continue_as_guest';
      // const properties = {
      //   type: 'continueAsGuest',
      // };
      // Smartlook.track('continue_as_guest', eventName, properties);
      localStorage.setItem('isGuest', true);
      localStorage.removeItem('PreselectedPatientId');
    }
  }, [authCtx?.authenticated, initialized]);

  useEffect(()=>{
    if(localStorage?.getItem('isGuest')){
      setIsGuest(localStorage?.getItem('isGuest'));
    }
  },[]);

  useEffect(() => {
    const params = {
      patientId: userData?.id,
    };
    if (userData?.id && !asterSecureLoyaltics) {
      dispatch(
        getLoyaltyCustomer({
          params,
          onSuccess: () => {},
          onFailure: (err) => {
            errorHandling(err, true, props?.screenName || 'HomePage', props?.pageType);
          },
        }),
      );
    }
  }, [userData?.id]);

  const DropdownButtonClicked = (value) => {
    if (value === 'Account') {
      router.push({ pathname: generateURL('/profile/myprofile') });
    }
    if (value === 'Logout') {
      // const clientId = getDataFromCookie('kcClientId');
      const requestParams = {
        // client_id: clientId || KEYCLOAK_SMS_CLIENTID,
        refreshToken: getDataFromCookie('kcRefreshToken'),
      };

      dispatch(
      authUserLogOut({
          requestParams,
          onSuccess: () => {
            clearAppStorage();
            authCtx?.logout();
            sendEventToSmartLook('logout', 'logout');
            if(localStorage.getItem('loginUsingUaePass')){
              dispatch(
                getUaePassLogoutRedirectUrl({
                  onSuccess: (response) => {
                    localStorage.removeItem('loginUsingUaePass');
                    const url = response?.body?.url;
                    window.location.href = generateURL(url);
                  },
                  onFailure: (err) => {
                    errorHandling(err);
                  },
                }),
              );
            }
            else {
              if (getIsInstoreWithSSR()) {
                window.location.assign(generateURL(ONLINE_PHARMACY_ROUTE));
              } else {
                window.location.assign(generateURL('/'));
              }
            }
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    }
  };

  const handleBellIconClicked = () => {
    setIsQuickNotification(!isQuickNotification);
    setShowNotification(false);
    dataLayerMenuClickEvent(props?.screenName, props?.pageType, CLICKEDMENU?.NOTIFICATION, router?.asPath);
  };

  const checkUnreadNotificationCount = () => {
    let count = 0;
    if (notifications && notifications.length > 0) {
      notifications.forEach((item) => {
        if (item.isRead === 0) {
          count += 1;
        }
      });
    }
    return count;
  };

  const mergeCartApiCall = () => {
    setIsMergeCartModalOpen(false);
    const { page } = getPage(router?.asPath);
    const param = {
      userId: userLogin?.id,
      "cart_type": CART_TYPES.AE,
      page,
    };
    if (userZoneData && userLogin?.id) {
      param.zones = encodeURIComponent(JSON.stringify(userZoneData));
      sessionStorage.setItem(SESSION_STORAGE_KEYS?.IS_MERGE_CART_CALLED, 'true');
      sessionStorage.removeItem(SESSION_STORAGE_KEYS?.OLD_CART_ID);
      mergeCartRef.current = true;
      dispatch(
        mergeCartDetails({
          param,
          onSuccess: (response) => {
            mergeCartRef.current = false;
            sessionStorage.setItem(SESSION_STORAGE_KEYS?.OLD_CART_ID, response?.cart_id);
            toast.success(response?.data?.message);
            fetchCartDetails({ cartIdParam: response?.cart_id });
          },
          onFailure: (err) => {
            sessionStorage.removeItem(SESSION_STORAGE_KEYS?.IS_MERGE_CART_CALLED);
            logger.error('merge cart failed', err, props?.screenName || '', props?.pageType)
            errorHandlingEpharmacy(err, true, props?.screenName || 'HomePage', props?.pageType);
          },
        }),
      );
    }
  };

  const LoginToOpen = () => {
    sendLoginEvent(props?.screenName, props?.pageType, router.asPath);
    authCtx.login({
      redirectUri: `${REDIRECT_URI}${generateURL(`?asPath=${encodeURIComponent(router.asPath)}`)}`,
    });
  };
  const LoginToCancelButton = () => {
    setShow(false);
  };

  const getToastControlMessage = (data) => {
    setToastControlMessage(data?.message);
    setToastControlImage(data?.toastImg || IC_TICK);
    -setToastControlClass(data?.toastClass || '');
  };

  useEffect(() => {
    if (window.innerWidth <= MIN_MOBILE_WIDTH) {
      if (isQuickNotification) document.body.style.overflow = 'hidden';
      else document.body.style.overflow = 'unset';
    }
    const checkIfClickedOutside = (e) => {
      if (isQuickNotification && ref.current && !ref.current.contains(e.target)) {
        setIsQuickNotification(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isQuickNotification]);

  React.useEffect(() => {
    if (toastControlMessage) {
      setTimeout(() => {
        setToastControlMessage(null);
      }, 4000);
    }
  }, [toastControlMessage]);

  useEffect(() => {
    if (userArea !== 'Select Your Location' && zoneData?.length !== 0) {
      if (userData?.id !== null && userData?.id !== undefined) {
        dataLayerSendEvent('user_configuration', {
          user_state: 'Logged In',
          user_area: userArea,
          user_pharmacy_zone: zoneData,
          user_id: userData?.id,
        });
      } else if (isGuest || isGuest === 'true') {
        dataLayerSendEvent('user_configuration', {
          user_state: 'Guest',
          user_area: userArea,
          user_pharmacy_zone: zoneData,
          user_id: '',
        });
      }
    }
  }, [isGuest, userArea, zoneData, userData?.id]);

  const handleResize = () => {
    if (window?.innerWidth <= MIN_MOBILE_WIDTH) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    if (window?.innerWidth <= 1000) {
      setShowHemburgerResponsive(true);
    } else {
      setShowHemburgerResponsive(false);
    }
  };
  useEffect(() => {
    handleResize();
    window?.addEventListener('resize', handleResize);
    return () => {
      window?.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('referralCode') && referralCode) {
      localStorage.setItem('referralCode', referralCode);
    }
    EventEmitter.subscribe('setToastControlMessage', (data) => getToastControlMessage(data), true);
    EventEmitter.subscribe('checkPatientInHis', (data) => checkPatientInHis(data), true);
    return () => {
      EventEmitter.unsubscribe('setToastControlMessage', (data) => getToastControlMessage(data));
      EventEmitter.unsubscribe('checkPatientInHis', (data) => checkPatientInHis(data));
    };
  }, []);

  useEffect(() => {
    if (router?.pathname?.includes(ONLINE_PHARMACY_ROUTE) && authCtx?.authenticated && !!userZoneData) {
      fetchWishList();
    }
    EventEmitter.subscribe('fetchWishList', (data) => fetchWishList(data), true);
    EventEmitter.subscribe('fetchCartDetails', (data) => fetchCartDetails(data), true);
    return () => {
      EventEmitter.unsubscribe('fetchWishList', () => fetchWishList());
      EventEmitter.unsubscribe('fetchCartDetails', (data) => fetchCartDetails(data));
    }
  }, [userZoneData, userLogin, guestLogin])

  useEffect(() => {
    setIsInStoreApp(instoreFlag);
    if (!('checkUserExist' in EventEmitter.events)) {
      EventEmitter.subscribe('checkUserExist', () => checkUserExistFunc());
    }
    if (!localStorage.getItem('userCountry')) {
      getUserCountry();
    }
    return () => {
      EventEmitter.unsubscribe('checkUserExist', () => checkUserExistFunc());
    };
  }, []);

  useEffect(() => {
    if (
      ((authCtx?.authenticated || userLogin) &&
        (router?.asPath === ONLINE_PHARMACY_ROUTE || /^\/online-pharmacy\/p\/[\da-zA-Z]*/.test(router?.asPath))) ||
      /^\/online-pharmacy\/mycart/.test(router?.asPath)
    ) {
      if (getCartV2Data && !router?.pathname?.includes('paymentsuccess')) {
        fetchCartDetails();
      }
    }
  }, [authCtx?.authenticated, router?.asPath, userLogin]);

  useEffect(() => {
    if ((guestLogin || userLogin) && isMergeCalled !== 'true') {
      if (!getCartV2Data || (getCartV2Data === undefined && !router?.pathname.includes('paymentsuccess'))) {
        fetchCartDetails();
      }
    }
  }, [getCartV2Data, userLogin, guestLogin]);

  useEffect(() => {
    if (getCartV2Data?.merge_shipment_available && router?.pathname?.indexOf('mycart') > 0) {
      setIsMergeCartModalOpen(getCartV2Data?.merge_shipment_available);
    }
    const selectedAddress = userAddresses?.find(address => address.selected === true);
    if(!mergeCartEnabled && authCtx?.authenticated && !guestLogin && userLogin && userZoneData && isMergeCalled !== 'true') {
        mergeCartApiCall();
    } else if (selectedAddress === undefined && !mergeCartRef.current){
      fetchCartDetails();
    }
  }, [userLogin, userZoneData]);

  useEffect(() => {
    if (isOpen) {
      document?.body?.classList?.add('overflow-hidden');
    } else {
      document?.body?.classList?.remove('overflow-hidden');
    }
  }, [isOpen]);

  const homecareBookings = (data) => {
    const bookings = [];
    let bookingIds = '';
    if (data && data.length) {
      data.map((item) => {
        if (item?.showServiceFeedback === true) {
          bookings.push(item?.bookingId);
        }
        return bookings;
      });
      bookingIds = bookings.join(',');
    }
    if (bookingIds && bookingIds !== '' && userLogin?.id) {
      router?.push({
        pathname: generateURL(`/home-care/feedback`),
        query: { bookingId: bookingIds, path: window.location.pathname },
      });
    }
  };

  const initGuestTokenTimer = () => {
    try {
      const guestToken = getDataFromCookie('Guest_Token');
      if (guestToken) {
        const decodedToken = jwtDecode(guestToken);
        const expiresIn = (decodedToken?.exp - new Date().getTime() / 1000) * 1000;
        clearTimeout(guestTokenTimer.current);
        guestTokenTimer.current = setTimeout(getGuestToken, expiresIn);
      }
    } catch (e) {
      logger.error('Error occurred in creating timer for guest token refresh', e);
    }
  };

  React.useEffect(() => {
    if (localStorage.getItem('fbToastMsg')) {
      setTimeout(() => {
        const toastMsg = localStorage.getItem('fbToastMsg');
        toast.success(toastMsg);
        localStorage.removeItem('fbToastMsg');
      }, 2000);
    }

    initGuestTokenTimer();
    return () => {
      clearTimeout(guestTokenTimer.current);
    };
  }, []);

  useEffect(() => {
    if ((isWobbleAnimation || cartIconAnimation) && cartBoxRef?.current) {
      cartBoxRef.current.classList.add("cartWobble");
      localStorage.removeItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION);
      setIsWobbleAnimation(false);
      cartIconAnimation = false;
      wobbleTimerRef.current = setTimeout(() => {
        cartBoxRef.current.classList.remove("cartWobble");
      }, cartCheckoutFlag?.cartIconAnimationTimer || 1000);
    }
  }, [cartIconAnimation, cartBoxRef?.current, isWobbleAnimation]);

  useEffect(() => {
    return() => {
      if(wobbleTimerRef.current)
        clearTimeout(wobbleTimerRef.current);
      localStorage.removeItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION);
    }
  }, []);

  const isNotSafari = useIsNotSafari();
  const getIsInstoreWithSSR = () => getIsInstoreApp() || props?.ssrInstore || false;

  const renderLoginComponent = () => {
    if (getIsInstoreWithSSR() && !authCtx?.authenticated) return null;

    return (
      <div className="loginSignup">
        {(!authCtx?.authenticated && !getIsInstoreWithSSR()) ? (
          <>
            <div
              className="ic cursor-pointer"
              onClick={() => {
                sendLoginEvent(props?.screenName, props?.pageType, router.asPath);
                authCtx.login({
                  redirectUri: `${REDIRECT_URI}${generateURL(`?asPath=${encodeURIComponent(router.asPath)}`)}`,
                });
              }}
            >
              <Image src={IC_USER} alt="IC USER" id="image_mask" data-sl="mask" priority />
            </div>
            <div
              className="label cursor-pointer"
              onClick={() => {
                sendLoginEvent(props?.screenName, props?.pageType, router.asPath);
                authCtx.login({
                  redirectUri: `${REDIRECT_URI}${generateURL(`?asPath=${encodeURIComponent(router.asPath)}`)}`,
                });
              }}
            >
              {t('Header.txtLoginRegister')}
            </div>
          </>
        ) : (
          <>
            {loading ? (
              <UserProfileSkeleton isMobile={isMobile} />
            ) : (
              <div className="profile_view">
                <div
                  className="ic cursor-pointer"
                  onClick={() => {
                    dataLayerSendEvent('profile_click', {
                      screen_name: 'pharmacy_Home_Page',
                    });
                    const properties = {
                      type: 'pharmacy_Home_Page',
                    };
                    sendEventToSmartLook('profile_click', properties);
                    if (window.innerWidth > MIN_MOBILE_WIDTH) {
                      router.push({ pathname: generateURL('/profile/myprofile') });
                    }
                  }}
                >
                  {!userData?.extension?.find((item) => item.url === 'nameInitials')?.valueString ? (
                    <Image
                      id="image_mask"
                      src={userData?.photo?.[0]?.url || IC_USER?.src}
                      alt="IC USER"
                      width={34}
                      height={34}
                      priority
                      data-sl="mask"
                    />
                  ) : (
                    <div className="avtarName" id="image_mask" data-sl="mask">
                      {userData?.extension?.find((item) => item.url === 'nameInitials')?.valueString}
                    </div>
                  )}
                </div>
                {userData?.name?.[0]?.text && (
                  <DropdownControl
                    align="end"
                    data={getIsInstoreWithSSR()
                      ? userDropdownData.filter(item => item.value === 'Logout')
                      : userDropdownData
                    }
                    theme="userDropdown"
                    caption={convertStringtoTitleCase(userData?.name?.[0]?.text)}
                    handleSelect={(value) => {
                      DropdownButtonClicked(value);
                      dataLayerMenu(value, 'DropDown', props?.screenName, '', '', value === 'Account' ? true : false);
                    }}
                    title
                  />
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  if (!isClient) return null;
  return (
    <>
      <HeaderStyled
        className={`${props?.customOuterClass && props?.customOuterClass} ${props?.shouldHideHeader && 'hide-header'} ${
          scrollY > 38 ? 'fixed' : ''
        } ${currentLang && isRTL(currentLang) ? 'rtl' : ''} ${isDisallowedSwitcher ? 'topZero' : ''}`}
      >
        {isNotSafari ? <SmartBanner /> : null}
        <Loader
          isLoading={
            (!props?.showLoader || !loading) &&
            props?.isMyWishlistPage &&
            !props?.isMyCartPage &&
            (getWishlistLoader || addToWishlistLoader || removeFromWishlistLoader)
          }
        />
        {props?.showLoader && (
          <Loader
            isLoading={
              loading || (!userLogin && !isGuest) || mergeCartLoader || newMergeCartLoader || cancelMergeCartLoader
            }
          />
        )}

        <Container ref={props?.headerContentRef}>
          <div className="content">
            {!getIsInstoreWithSSR() && (web_feature_flaging?.isHamburgerMenuEnable || showHemburgerResponsive) && (
              <>
                <div
                  data-test="menuBtn"
                  className="menuButton"
                  onClick={() => {
                    setIsOpen(!isOpen);
                    document.body.classList.add('overflow-hidden');
                    setShowActiveMenu(false);
                  }}
                >
                  <div className={`ic ${isOpen ? 'hide' : ''}`}>
                    <Image src={isOpen ? IC_CLOSE : IC_HAMBURGER} alt={isOpen ? 'IC_CLOSE' : 'IC_HAMBURGER'} priority />
                  </div>
                  <div className={`label ${isOpen ? 'hide' : ''}`}>Menu</div>
                </div>
                <MenuSideNavigation
                  className={`${scrollY > 38 ? 'fixed' : ''}`}
                  onMenuClick={() => setIsOpen(false)}
                  guest={isGuest}
                  setIsOpen={(val) => setIsOpen(val)}
                  isOpen={isOpen}
                  history={props?.history}
                  setShowActiveMenu={setShowActiveMenu}
                  showActiveMenu={showActiveMenu}
                  screenName={props?.screenName}
                  pageType={props?.pageType}
                />
              </>
            )}
            <div className="logo">
              <Link href={web_feature_flaging?.isBreadcrumbAEDisabled ? generateURL(ONLINE_PHARMACY_ROUTE) : generateURL(HOME)} passHref>
                <a className="logo-link">
                  <Image src={isArLang ? LOGO_ASTER_AR : LOGO_ASTER} width="105px" height="30px" alt="Aster" priority />
                </a>
              </Link>
            </div>
            <div className={props?.globalSearch || isHomeCarePage ? 'searchGlobalBox searchBox' : 'searchBox'}>
              {props?.search && (
                <SearchBox
                  globalSearch={props?.globalSearch}
                  screenName={props?.screenName}
                  referrerPage={props?.referrerPage}
                />
              )}
            </div>
            {(!isGuest && !getIsInstoreWithSSR() && web_feature_flaging?.isNotificationEnable) ? (
              <div className="notificationBox" onClick={handleBellIconClicked} ref={ref}>
                <div className="ic">
                  <Image src={IC_BELL} alt="IC_BELL" priority />
                  {checkUnreadNotificationCount() > 0 && userData?.length !== 0 && <div className="dot" />}
                </div>
                {isQuickNotification && (
                  <div data-test="div2" className="notification-scroll">
                    <QuickNotifications customClass="notificationDropdown" />
                  </div>
                )}
              </div>
            ) : null}
            {!getIsInstoreWithSSR() && web_feature_flaging?.isSecurePointsEnabledKsaUser &&(
              <div className="pointBox">
                {(() => {
                  if (asterSecureLoyaltics?.availablePoints) {
                    return (
                      <>
                        <Link href={generateURL("/astersecure")} passHref>
                          <a className="ic cursor-pointer" onClick={() => dataLayerMenuClickEvent(props?.screenName, props?.pageType, CLICKEDMENU?.SECURE, router?.asPath)}>
                            <Image src={IC_HEART_MANDALAY} priority alt="Aster Secure" />
                          </a>
                        </Link>
                        <Link href={generateURL("/astersecure")} passHref>
                          <a className="details cursor-pointer" onClick={() => dataLayerMenuClickEvent(props?.screenName, props?.pageType, CLICKEDMENU?.SECURE, router?.asPath)}>
                            <div className="value">{asterSecureLoyaltics?.availablePoints || '0'}</div>
                            <div className="label">{t('Header.Pts')}</div>
                          </a>
                        </Link>
                      </>
                    );
                  }
                  return isMobile ? (
                    <Link href={generateURL("/astersecure")} passHref>
                      <a className="ic" onClick={() => dataLayerMenuClickEvent(props?.screenName, props?.pageType, CLICKEDMENU?.SECURE, router?.asPath)}>
                        <Image src={IC_HEART_MANDALAY} priority alt="Aster Secure" />
                      </a>
                    </Link>
                  ) : (
                    <Link href={generateURL("/astersecure")} passHref>
                      <a className="ic-secure cursor-pointer" onClick={() => dataLayerMenuClickEvent(props?.screenName, props?.pageType, CLICKEDMENU?.SECURE, router?.asPath)}>
                        <Image src={LOGO_ASTER_SECURE} width="86px" height="29px" priority alt="Aster Secure" />
                      </a>
                    </Link>
                  );
                })()}
              </div>
            )}
            {web_feature_flaging?.isLoginEnable && renderLoginComponent()}
            {web_feature_flaging?.isCartEnable &&
              <div className="cartBox" ref={cartBoxRef}>
                <div className="ic">
                  <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/mycart`)} passHref>
                    <a>
                      <Image src={IC_CART_GREY} alt="IC Cart " priority />

                      {myCartTotalItems ? <div className="badge">{myCartTotalItems}</div> : null}
                    </a>
                  </Link>
                </div>
              </div>
            }
          </div>
          {props?.mobileSearch && (
            <div
              className={props?.globalSearch || isHomeCarePage ? 'searchGlobalBox mobileSearchBox' : 'mobileSearchBox'}
            >
              <SearchBox
                globalSearch={props?.globalSearch}
                screenName={props?.screenName}
                referrerPage={props?.referrerPage}
              />
            </div>
          )}
          {meeting && <VideoCallPopover />}
        </Container>

        {isMergeCartModalOpen && mergeCartEnabled && (
          <CustomModal
            outerCustomClass="epharmacy"
            customClass="merge-cart-section"
            bodyTextCenter
            btnFullWidth
            modalTitle={`Hey ${userLogin?.name?.[0]?.given?.[0]}!`}
            size="md"
            footerAlignment="center"
            closeButton
            crossPressed={() => {
              setIsMergeCartModalOpen(false);
              fetchCartDetails();
            }}
          >
            <p className="mb-4">
              {`There are ${myCartTotalItems} items already added to your cart. Do you want to replace the cart with these items or Merge
            the cart?`}
            </p>
            <ButtonBase
              enableFullWidth
              customClass="merge-cart-btn"
              variant="primary epharmacy "
              text="Merge Cart"
              onClick={() => mergeCartApiCall()}
            />
            <ButtonBase
              enableFullWidth
              customClass="merge-cart-btn"
              variant="secondary epharmacy "
              text="Create a new cart"
              onClick={() => {}}
            />
            <ButtonBase
              customClass="merge-cart-btn-cancel"
              enableFullWidth
              variant="link epharmacy "
              text="Cancel"
              onClick={() => {}}
            />
          </CustomModal>
        )}
        {show && (
          <CustomModal
            bodyTextCenter
            footerBtnFullWidth
            modalTitle="Login/Register"
            size="md"
            footerAlignment="center"
            primaryButtonText="Login/Register"
            secondaryButtonText="Cancel"
            primaryButtonClicked={LoginToOpen}
            seconderyButtonClcked={LoginToCancelButton}
          >
            <p className="mb-0 font-17">{t('EPharmacyHome.loginRegDesc')}</p>
          </CustomModal>
        )}
      </HeaderStyled>
      {toastControlMessage && (
        <ToastControl
          className={`${scrollY > 38 ? 'fixed' : ''}`}
          iconWidth="20px"
          iconHeight="20px"
          imgError={toastControlImage}
          text={toastControlMessage}
          variant={`green-dark-box justify-content-center toast-image floating-wrapper ${toastControlClass}`}
        />
      )}
    </>
  );
};

Header.defaultProps = {
  search: true,
  showLoader: false,
  mobileSearch: true,
  globalSearch: false,
  isMyCartPage: false,
  isMyWishlistPage: false,
  screenName: '',
  customOuterClass: '',
  history: '',
  setCartPageLoading: () => {},
  shouldHideHeader: false,
  pageType: '',
  ssrInstore: false,
  setCartRes: () => {}
};

Header.propTypes = {
  search: PropTypes.bool,
  globalSearch: PropTypes.bool,
  showLoader: PropTypes.bool,
  mobileSearch: PropTypes.bool,
  isMyCartPage: PropTypes.bool,
  headerContentRef: PropTypes.object,
  isMyWishlistPage: PropTypes.bool,
  screenName: PropTypes.string,
  customOuterClass: PropTypes.string,
  history: PropTypes.string,
  setCartPageLoading: PropTypes.func,
  shouldHideHeader: PropTypes.bool,
  pageType: PropTypes.string,
  ssrInstore: PropTypes.bool,
  setCartRes: PropTypes.func,
};

export default Header;

